export default "__VITE_ASSET__C2ZS4xTZ__"